import React, { useMemo } from "react";
import preview from '../assets/img/preview.png';

export function Project(ts) {
    const { i18n } = ts;
    const texto = i18n['t']
    const obj = i18n['i18n']

    return (
        <>
            <section id="articles-projects" className="text-gray-700 body-font border-t border-gray-200">
                <div className="container px-5 py-24 mx-auto">
                    <div className="flex flex-wrap w-full mb-20 flex-col items-center text-center">
                        <h1 className="sm:text-3xl text-2xl font-medium title-font mb-2 text-gray-900">{texto('articles_projects')}</h1>
                        <p className="lg:w-1/2 w-full leading-relaxed text-base">
                            {texto('project_1')}
                        </p>
                    </div>
                    <div className="flex flex-wrap -m-4">
                        <div className="xl:w-1/3 md:w-1/2 p-4">
                            <div className="border border-gray-300 p-6 rounded-lg">
                                <div
                                    className="w-full inline-flex items-center justify-center rounded-full bg-sky-100 text-sky-500 mb-4">
                                    <img className="object-cover object-center h-full w-full" src="https://i.ibb.co/ZHGrn4B/work4.jpg" />
                                </div>
                                
                                <div>
                                    <h2 className="text-lg text-gray-900 font-medium title-font mb-2">
                                        {texto('project_2')}
                                    </h2>
                                    <p></p>
                                    <p className="leading-relaxed text-base">
                                    {texto('project_3')}
                                    </p>
                                    <a href="https://medium.com/@willian.buqui/teste-a-b-react-js-com-nginx-e-docker-1aef402461a4"
                                        target="_blank" className="mt-3 text-sky-500 inline-flex items-center">{texto('learn_more')}
                                        <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                            stroke-width="2" className="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                            <path d="M5 12h14M12 5l7 7-7 7"></path>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="xl:w-1/3 md:w-1/2 p-4">
                            <div className="border border-gray-300 p-6 rounded-lg">
                                <div
                                    className="w-full inline-flex items-center justify-center rounded-full bg-sky-100 text-sky-500 mb-4">
                                    <img className="object-cover object-center h-full w-full" src={preview} />
                                </div>
                                <br/>
                                <br/>
                                <br/>
                                <br/>
                                <div>
                                    <h2 className="text-lg text-gray-900 font-medium title-font mb-2">
                                        {texto('project_4')}
                                    </h2>
                                    <p></p>
                                    <p className="leading-relaxed text-base">
                                    {texto('project_5')}
                                    </p>
                                    <a href="https://medium.com/@willian.buqui/criando-seu-portifolio-e-publicando-no-aws-a7aa02ac9af2"
                                        target="_blank" className="mt-3 text-sky-500 inline-flex items-center">{texto('learn_more')}
                                        <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                            stroke-width="2" className="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                            <path d="M5 12h14M12 5l7 7-7 7"></path>
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                        {/* <div className="xl:w-1/3 md:w-1/2 p-4">
                                <div className="border border-gray-300 p-6 rounded-lg">
                                    <div
                                        className="w-full inline-flex items-center justify-center rounded-full bg-sky-100 text-sky-500 mb-4">
                                        <img className="object-cover object-center h-full w-full" src="https://i.ibb.co/ZHGrn4B/work4.jpg" />
                                    </div>
                                    <div>
                                        <h2 className="text-lg text-gray-900 font-medium title-font mb-2">Blog Title</h2>
                                        <p></p>
                                        <p className="leading-relaxed text-base">Lorem ipsum dolor sit, amet consectetur adipisicing
                                            elit. Beatae distinctio tenetur eaque aspernatur aut molestias amet natus temporibus
                                            quaerat odio.</p>
                                        <a href="#" className="mt-3 text-sky-500 inline-flex items-center">Learn More
                                            <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                                stroke-width="2" className="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                                <path d="M5 12h14M12 5l7 7-7 7"></path>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="xl:w-1/3 md:w-1/2 p-4">
                                <div className="border border-gray-300 p-6 rounded-lg">
                                    <div
                                        className="w-full inline-flex items-center justify-center rounded-full bg-sky-100 text-sky-500 mb-4">
                                        <img className="object-cover object-center h-full w-full" src="https://i.ibb.co/ZHGrn4B/work4.jpg" />
                                    </div>
                                    <div>
                                        <h2 className="text-lg text-gray-900 font-medium title-font mb-2">Blog Title</h2>
                                        <p></p>
                                        <p className="leading-relaxed text-base">Lorem ipsum dolor sit, amet consectetur adipisicing
                                            elit. Beatae distinctio tenetur eaque aspernatur aut molestias amet natus temporibus
                                            quaerat odio.</p>
                                        <a href="#" className="mt-3 text-sky-500 inline-flex items-center">Learn More
                                            <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"
                                                stroke-width="2" className="w-4 h-4 ml-2" viewBox="0 0 24 24">
                                                <path d="M5 12h14M12 5l7 7-7 7"></path>
                                            </svg>
                                        </a>
                                    </div>
                                </div>
                            </div> */}

                    </div>

                </div>
            </section>
        </>
    );


}
